import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmAllVehiclesFilter = (bodyStyle, modelYear, filteredResultsCount, gtmFees, gtmTax) => {
    var _a;
    const gtmPayload = filterUndefinedAndEmptyValues({
        event: 'all_vehicles_filter',
        body_style: (_a = bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.replace(/<[^>]*>/g, ' ')) === null || _a === void 0 ? void 0 : _a.trim(),
        model_year: modelYear,
        models_available: filteredResultsCount,
        include_fees: gtmFees,
        include_sales_taxes: gtmTax,
    });
    gtmEvent(gtmPayload);
};
export default gtmAllVehiclesFilter;
